<div class="container MenuDatos">
    <form [formGroup]="registrarForm">

        <!-- 📋 TÍTULO PRINCIPAL -->
        <h1 class="section-title">Mis datos personales</h1>

        <!-- 📧 INFORMACIÓN PERSONAL -->
        <div class="form-group">
            <div class="form-grid mixed-columns">
                <div class="md-form">
                    <label for="txtCorreo" class="required">Correo electrónico</label>
                    <input
                        mdbInput
                        disabled
                        type="email"
                        formControlName="txtCorreo"
                        id="txtCorreo"
                        class="form-control"
                        placeholder="ejemplo@correo.com"
                        (blur)="validarCampo('txtCorreo')"
                    />
                </div>
                <div class="md-form">
                    <label for="txtTipoDocumento" class="required">Tipo de Documento</label>
                    <select
                        class="custom-select"
                        formControlName="txtTipoDocumento"
                        id="txtTipoDocumento"
                        (change)="onChangeTipoDoc($event.target.value)"
                        (blur)="validarCampo('txtTipoDocumento')"
                    >
                        <option selected disabled>Seleccionar</option>
                        <option *ngFor="let tipo of listTipoDocumento?.response?.list" [value]="tipo.masterId">
                            {{ tipo.masterDescription }}
                        </option>
                    </select>
                </div>
                <div class="md-form">
                    <label for="txtNroDocumento" class="required">Número de Documento</label>
                    <input
                        type="text"
                        formControlName="txtNroDocumento"
                        id="txtNroDocumento"
                        class="form-control"
                        placeholder="12345678"
                        [maxlength]="maxLengthTxtNroDocumento"
                        (keypress)="fc_ValTextDocumento($event)"
                        (blur)="validarCampo('txtNroDocumento')"
                    />
                </div>
            </div>
        </div>

        <!-- 👤 DATOS PERSONALES -->
        <div class="form-group">
            <div class="form-grid two-columns">
                <div class="md-form">
                    <label for="txtNombre" class="required">Nombres</label>
                    <input
                        mdbInput
                        formControlName="txtNombre"
                        type="text"
                        id="txtNombre"
                        class="form-control"
                        placeholder="Ingrese sus nombres"
                        (blur)="validarCampo('txtNombre')"
                    />
                </div>
                <div class="md-form">
                    <label for="txtApellidos" class="required">Apellidos</label>
                    <input
                        mdbInput
                        formControlName="txtApellidos"
                        type="text"
                        id="txtApellidos"
                        class="form-control"
                        placeholder="Ingrese sus apellidos"
                        (blur)="validarCampo('txtApellidos')"
                    />
                </div>
            </div>
        </div>

        <!-- 📱 CONTACTO -->
        <div class="form-group">
            <div class="form-grid two-columns">
                <div class="md-form">
                    <label for="txtTelefono" class="required">Número de Teléfono</label>
                    <input
                        mdbInput
                        type="tel"
                        formControlName="txtTelefono"
                        id="txtTelefono"
                        class="form-control"
                        placeholder="987654321"
                        (blur)="validarCampo('txtTelefono')"
                    />
                </div>
                <div class="md-form">
                    <label for="txtFechaNacimiento" class="required">Fecha de Nacimiento</label>
                    <input
                        mdbInput
                        type="date"
                        formControlName="txtFechaNacimiento"
                        id="txtFechaNacimiento"
                        class="form-control"
                        (blur)="validarCampo('txtFechaNacimiento')"
                    />
                </div>
            </div>
        </div>

        <!-- 📍 UBICACIÓN -->
        <div class="form-group">
            <h3 class="section-subtitle">Ubicación</h3>
            <div class="form-grid three-columns">
                <div class="md-form">
                    <label for="txtDepartamento" class="required">Departamento</label>
                    <select
                        class="custom-select"
                        (change)="cboDepartamentoVal = $event.target.value; obtenerProvincia($event.target.value)"
                        formControlName="txtDepartamento"
                        id="txtDepartamento"
                        (blur)="validarCampo('txtDepartamento')"
                    >
                        <option selected disabled>Seleccionar departamento</option>
                        <option *ngFor="let departamento of departamento?.response?.list" [value]="departamento.codeDepartment">
                            {{ departamento.name }}
                        </option>
                    </select>
                </div>
                <div class="md-form">
                    <label for="txtProvincia" class="required">Provincia</label>
                    <select
                        class="custom-select"
                        (change)="obtenerDistritos(cboDepartamentoVal, $event.target.value)"
                        formControlName="txtProvincia"
                        id="txtProvincia"
                        (blur)="validarCampo('txtProvincia')"
                    >
                        <option selected disabled>Seleccionar provincia</option>
                        <option *ngFor="let provincia of provincia?.response?.list" [value]="provincia.codeProvince">
                            {{ provincia.name }}
                        </option>
                    </select>
                </div>
                <div class="md-form">
                    <label for="txtDistrito" class="required">Distrito</label>
                    <select
                        class="custom-select"
                        formControlName="txtDistrito"
                        id="txtDistrito"
                        (blur)="validarCampo('txtDistrito')"
                    >
                        <option selected disabled>Seleccionar distrito</option>
                        <option *ngFor="let distrito of distritoResponse?.response?.list" [value]="distrito.codeDistrict">
                            {{ distrito.name }}
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <!-- 🔐 CAMBIO DE CONTRASEÑA -->
        <div class="form-group">
            <h3 class="section-subtitle">Cambio de Contraseña (Opcional)</h3>
            <div class="form-grid three-columns">
                <div class="md-form">
                    <label for="txtPasswordActual">Contraseña Actual</label>
                    <input
                        mdbInput
                        type="password"
                        formControlName="txtPasswordActual"
                        id="txtPasswordActual"
                        class="form-control"
                        placeholder="Ingrese su contraseña actual"
                        (blur)="validarCampo('txtPasswordActual')"
                    />
                </div>
                <div class="md-form">
                    <label for="txtPassword">Nueva Contraseña</label>
                    <input
                        mdbInput
                        type="password"
                        formControlName="txtPassword"
                        id="txtPassword"
                        class="form-control"
                        placeholder="Ingrese nueva contraseña"
                        (blur)="validarCampo('txtPassword')"
                    />
                </div>
                <div class="md-form">
                    <label for="txtPassword2">Confirmar Nueva Contraseña</label>
                    <input
                        mdbInput
                        type="password"
                        formControlName="txtPassword2"
                        id="txtPassword2"
                        class="form-control"
                        placeholder="Confirme su nueva contraseña"
                        (blur)="validarCampo('txtPassword2')"
                    />
                </div>
            </div>
        </div>

        <!-- Checkbox de Tratamiento de Datos Adicionales -->
        <div class="form-group">
            <h3 class="section-subtitle">Privacidad</h3>
            <div class="form-check" style="display: flex; align-items: flex-start; gap: 10px;">
                <input
                    type="checkbox"
                    class="form-check-input"
                    id="chkTratamientoDatos"
                    [(ngModel)]="acceptAdditionalDataTreatment"
                    [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="onPrivacyChange()"
                    style="width: 18px; height: 18px; min-width: 18px; cursor: pointer; margin-top: 3px;"
                >
                <label class="form-check-label" for="chkTratamientoDatos" style="font-size: 14px; cursor: pointer; text-align: left;">
                    Autorizo el <span style="text-decoration: underline; color: #c41e3a; cursor: pointer;" (click)="onClickTratamientoDatos(); $event.stopPropagation()">Tratamiento de mis datos para fines adicionales</span> (puedo revocar este consentimiento en cualquier momento)
                </label>
            </div>
        </div>

        <!-- Modal de Tratamiento de Datos -->
        <app-modal-tratamiento-datos
            [isVisible]="showModalTratamientoDatos"
            (onClose)="showModalTratamientoDatos = false">
        </app-modal-tratamiento-datos>

        <!-- 💾 BOTÓN DE GUARDAR -->
        <div class="button-container">
            <button
                type="button"
                class="btnRegistrar"
                (click)="actualizarUsuario()"
                [disabled]="!registrarForm.dirty && !privacyChanged"
            >
                <i class="fas fa-save"></i>
                Guardar Cambios
            </button>
        </div>
    </form>
</div>
